import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import {
  USER_DETAILS,
  ADD_NOTIFICATION,
  EDIT_NOTIFICATION,
  NOTIFICATION_MANAGEMENT,
  NOTIFICATION_ACTIVITY_LOG,
} from "../../../../navigation/routes";
import { history } from "../../../../store/configure/configureStore";

// import "./UserManagementStyles.scss";

import SendNotificationView from "./SendNotificationView";
import {
  getMobileAppUserList,
  getMobileAppUserById,
  addUser,
  editUser,
  deleteUser,
  //
  updateRowsPerPageOfUsersSendNotification,
  updateSearchFiltersOfUsersSendNotification,
  updateCurrentPageOfUsersSendNotification,
} from "../../../../store/mobileAppUserManagement/mobileAppUserManagementActions";
import {
  getSubscriptionList,
  getTopicList,
} from "../../../../store/master/masterActions";
import {
  sendNotification,
  updateSendNotificationTabs,
  //
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
} from "../../../../store/notificationManagement/notificationManagementActions";
import { USERS } from "../../../../constants/constants";

class MobileAppUserManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: this?.props?.fields || {
        searchString: "",
        subscription: [],
      },
      sendNotificationForAllCheckbox: false,
      showModal: {
        showViewModal: false,
        showWarningForRowTagsWhenNavigatingToOtherTab: false,
      },
      errors: {},
      userData: {},
      currentPage: this.props.currentPage || 1,
      rowsPerPage: this.props?.rowsPerPage || { label: "10", value: 10 },
      //
      selectedRowsData: [],
      selectedRowsDataOfTopic: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    this.stateUpdatesOnComponentUpdates(prevProps, prevState);
  }

  //--------------------------update state on component update
  stateUpdatesOnComponentUpdates = (prevProps, prevState) => {
    if (prevProps.currentPage !== this.props?.currentPage) {
      this.setState((prev) => ({
        ...prev,
        currentPage: this.props?.currentPage,
      }));
    }
  };

  componentDidMount() {
    this.fetchMobileAppUserList();
    this.props.getSubscriptionList();
    this.props.getTopicList();
  }

  componentWillUnmount() {
    this.resetTheReduxStateOnUnmount();
  }

  resetTheReduxStateOnUnmount = () => {
    //--------------------------reset redux rowsPerPage state when unmounting
    const resetRowsPerPageData = { label: "10", value: 10 };
    this.props?.updateRowsPerPageOfUsersSendNotification(resetRowsPerPageData);
    this.props?.updateCurrentPageOfUsersSendNotification(1);
    //--------------------------reset redux fields state when unmounting
    const resetFields = { searchString: "" };
    this.props.updateSearchFiltersOfUsersSendNotification(resetFields);

    this.props.updateSendNotificationTabs(USERS);

    const location = window?.location?.pathname;
    if (
      !location?.includes(EDIT_NOTIFICATION) &&
      !location?.includes(NOTIFICATION_ACTIVITY_LOG) &&
      !location?.includes(NOTIFICATION_MANAGEMENT)
    ) {
      //--------------------------reset redux rowsPerPage state when unmounting
      const resetRowsPerPageData = { label: "10", value: 10 };
      this.props?.updateRowsPerPage(resetRowsPerPageData);
      this.props?.updateCurrentPage(1);
      //--------------------------reset redux fields state when unmounting
      const resetFields = { searchString: "" };
      this.props.updateSearchFilters(resetFields);
    }
  };

  //--------------------------field handlers

  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    this.setState({
      fields: { ...this.state.fields, [field]: target.value },
      errors: {},
    });
  };

  handleTableRowsChange = (value) => {
    this.setState(
      (prev) => ({ ...prev, rowsPerPage: value, currentPage: 1 }),
      () => this.fetchMobileAppUserList()
    );
  };

  handleChangePage = (page) => {
    console.log("page", page);

    this.setState(
      (prev) => ({ ...prev, currentPage: page }),
      () => this.fetchMobileAppUserList()
    );
  };

  //--------------------------Search user
  // onChangeSearchInput = (e) => {
  //   const { value } = e.target;
  //   this.setState(
  //     (prev) => ({
  //       ...prev,
  //       fields: { ...prev.fields, searchString: value },
  //     }),
  //     () => {
  //       if (this.state.fields?.searchString === "") {
  //         this.fetchMobileAppUserList();
  //       }
  //       //update redux state
  //       this.props.updateSearchFiltersOfUsersSendNotification(this?.state?.fields);
  //     }
  //   );
  // };

  onChangeSearchInput = (e) => {
    const field = e.target.name;
    const { value } = e.target;
    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[field]; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            [field]: value,
          },
          errors: updatedErrors,
        };
      },
      () => {
        if (this.state.fields?.searchString === "") {
          this.fetchMobileAppUserList();
        }
        //update redux state
        this.props.updateSearchFiltersOfUsersSendNotification(
          this?.state?.fields
        );
      }
    );
  };

  // onClickSearch = () => {
  //   this.fetchMobileAppUserList(1);
  // };

  onClickSearch = () => {
    var fields = this.state.fields;
    console.log("fields", fields);

    const validatorFields = {
      required: ["searchString"],
    };
    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fields)
      // fields
    );

    // Add custom error message
    const updatedErrors = {
      ...errors,
      searchString: errors?.searchString && "Please enter valid input",
    };

    this.setState({ ...this.state, errors: updatedErrors });

    if (!Object.keys(errors).length) {
      this.fetchMobileAppUserList(1);
    }
  };

  // handleClear = () => {
  //   // console.log(this.state.fields);
  //   this.setState(
  //     (prev) => ({
  //       ...prev,
  //       fields: { ...prev.fields, searchString: "" },
  //     }),
  //     () => {
  //       if (this.state.fields?.searchString === "") {
  //         this.fetchMobileAppUserList();
  //       }
  //       //update redux state
  //       this.props.updateSearchFiltersOfUsersSendNotification(this?.state?.fields);
  //     }
  //   );
  // };

  handleClear = () => {
    // console.log(this.state.fields);
    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors.searchString; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            searchString: "",
          },
          errors: updatedErrors,
        };
      },
      () => {
        if (this.state.fields?.searchString === "") {
          this.fetchMobileAppUserList();
        }
        //update redux state
        this.props.updateSearchFiltersOfUsersSendNotification(
          this?.state?.fields
        );
      }
    );
  };

  //--------------------------Modal Controls
  onClickViewUser = (data) => {
    // this.setState((prevState) => ({
    //   showModal: { ...prevState.showModal, showViewModal: true },
    //   userData: data,
    // }));

    this.props.getMobileAppUserById(data?._id, () => {
      this.setState((prevState) => ({
        showModal: { ...prevState.showModal, showViewModal: true },
        userData: this.props.mobileUserDataById,
      }));
    });
  };

  onTabChangeShowWarningModal = () => {
    this.setState((prevState) => ({
      showModal: {
        ...prevState,
        showWarningForRowTagsWhenNavigatingToOtherTab: true,
      },
    }));
  };

  onCloseModal = () => {
    this.setState((prevState) => ({
      showModal: {
        showViewModal: false,
        showWarningForRowTagsWhenNavigatingToOtherTab: false,
      },
    }));
  };

  //--------------------------reset selection data
  resetSelectedRowsOnTabChange = () => {
    this.setState((prevState) => ({
      ...prevState,
      sendNotificationForAllCheckbox: false,
      selectedRowsData: [],
      selectedRowsDataOfTopic: [],
    }));
  };

  fetchMobileAppUserList = (page) => {
    const { searchString, subscription } = this.state?.fields;
    const { currentPage, rowsPerPage } = this.state;
    const data = {
      isActive: true,
      searchString: searchString?.trim(),
    };

    if (subscription?.length > 0) {
      const subscriptionTitles = subscription?.map((item) => item?.name);
      data.subscription = subscriptionTitles;
    }

    this.props.getMobileAppUserList(
      data,
      page ? page : currentPage,
      rowsPerPage?.value
    );
  };

  //--------------------------Row Selection
  handleSelectedRows = (selectedRows) => {
    // console.log("handleSelectedRows", selectedRows);
    this.setState(
      (prev) => ({
        ...prev,
        selectedRowsData: selectedRows,
      }),
      () => console.log("user", this.state.selectedRowsData)
    );
  };

  handleSelectedRowsOfTopic = (selectedRows) => {
    // console.log("handleSelectedRows", selectedRows);
    this.setState(
      (prev) => ({
        ...prev,
        selectedRowsDataOfTopic: selectedRows,
      }),
      () => console.log("topic", this.state.selectedRowsDataOfTopic)
    );
  };

  //--------------------------filter based on Subscription

  onClickSubscriptionDropDownFilterOptions = (value) => {
    // console.log("value", value);

    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          subscription: value ? value : [], // Set empty array if value is undefined or null
        },
        currentPage: 1,
      }),
      () => {
        this.fetchMobileAppUserList();
        //update redux state
        this.props.updateSearchFiltersOfUsersSendNotification(
          this?.state?.fields
        );
      }
    );
  };

  //--------------------------Submit
  onClickSend = () => {
    //get id from param
    const notificationId = this.props.match.params.id;

    //extracted only Id's
    // const userIds = this.state?.selectedRowsData?.map((item) => item?.id);
    const userIds = this.state?.selectedRowsData?.map((item) => item?.userId);
    console.log("userIds", userIds);

    // const data = {
    //   notificationId: notificationId,
    //   userIds: userIds || [],
    // };

    // Build the data object conditionally
    const data = {
      notificationId: notificationId,
      ...(this.state.sendNotificationForAllCheckbox
        ? { topic: "all" }
        : { userIds: userIds || [] }),
    };

    const topic = this.state?.selectedRowsDataOfTopic?.find(
      (item) => item?.value
    );

    const topicTabData = {
      notificationId: notificationId,
      topic: topic?.value || null,
    };

    const dynamicDataBasedOnTab = {
      Users: data,
      Topics: topicTabData,
    };

    const payloadData =
      dynamicDataBasedOnTab[this.props.activeSendNotificationTab];
    console.log("payloadData", payloadData);

    this.props.sendNotification(payloadData, () => {
      history.push(NOTIFICATION_MANAGEMENT);
    });
  };

  handleCheckBoxChange = () => {
    this.setState((prev) => ({
      sendNotificationForAllCheckbox: !prev.sendNotificationForAllCheckbox,
    }));
  };

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    //--------------------------dropdown options

    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    const filterBasedOnPersistedData = (options, filteringProperty, id) => {
      var filteredData = [];
      // filteredData = options?.filter((item) => item[filteringProperty] === id);
      filteredData = options?.filter(
        (item) => id?.some((idItem) => idItem.name === item[filteringProperty]) // Matching by 'name', or use '_id' if needed
      );

      return filteredData;
    };

    const persistedData = {
      //this is used for check marking selected filter list
      subscription: filterBasedOnPersistedData(
        this.props.subscriptionList,
        "name",
        this.state.fields.subscription
      ),
    };

    // console.log("persistedData", persistedData);

    return (
      <SendNotificationView
        //all the states
        fields={this.state?.fields}
        sendNotificationForAllCheckbox={
          this.state.sendNotificationForAllCheckbox
        }
        showModal={this.state?.showModal}
        userData={this.state?.userData}
        mobileUserList={this.props.mobileUserList}
        topicList={this.props.topicList}
        selectedRowsData={this.state.selectedRowsData}
        selectedRowsDataOfTopic={this.state.selectedRowsDataOfTopic}
        currentPage={this.state.currentPage}
        rowsPerPage={this.state?.rowsPerPage}
        //modal controls
        onClickViewUser={this.onClickViewUser}
        onTabChangeShowWarningModal={this.onTabChangeShowWarningModal}
        handleCloseModal={this.onCloseModal}
        errors={this.state.errors}
        //input handler
        onChangeSearchInput={this.onChangeSearchInput}
        handleInputChange={this.handleInputChange}
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        handleClear={this.handleClear}
        handleCheckBoxChange={this.handleCheckBoxChange}
        //
        subscriptionList={this.props.subscriptionList}
        persistedData={persistedData}
        //
        handleSelectedRows={this.handleSelectedRows}
        handleSelectedRowsOfTopic={this.handleSelectedRowsOfTopic}
        resetSelectedRowsOnTabChange={this.resetSelectedRowsOnTabChange}
        //API's
        onClickSearch={this.onClickSearch}
        onClickSend={this.onClickSend}
        onClickSubscriptionDropDownFilterOptions={
          this.onClickSubscriptionDropDownFilterOptions
        }
        //dropdown options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //
        activeSendNotificationTab={this.props.activeSendNotificationTab}
        updateSendNotificationTabs={this.props.updateSendNotificationTabs}
        //
        userPermissions={this.props.userPermissions}
        userRole={this.props.userRole}
        //
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

MobileAppUserManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  mobileUserList: state.mobileUserManagement.mobileUserList,
  mobileUserDataById: state.mobileUserManagement.mobileUserDataById,
  fields: state.mobileUserManagement.fieldsForUsersSendNotification,
  currentPage: state.mobileUserManagement.currentPageOfUsersSendNotification,
  rowsPerPage: state.mobileUserManagement.rowsPerPageOfUsersSendNotification,
  activeSendNotificationTab:
    state.notificationManagement.activeSendNotificationTab,
  //
  subscriptionList: state.master.subscriptionList,
  topicList: state.master.topicList,
  //
  userPermissions: state.auth.userPermissions,
  userRole: state.auth.userRole,
});

export default connect(mapStateToProps, {
  getSubscriptionList,
  getMobileAppUserList,
  getMobileAppUserById,
  getTopicList,
  //
  updateRowsPerPageOfUsersSendNotification,
  updateSearchFiltersOfUsersSendNotification,
  updateCurrentPageOfUsersSendNotification,
  //
  sendNotification,
  updateSendNotificationTabs,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(MobileAppUserManagementContainer);
